import { gql } from '@apollo/client'

export const GET_ORDER_JOURNEY = gql`
  query GetOrderJourney($orderNumber: String!) {
    order(number: $orderNumber) {
      id
      cdpJourney
      lineItems {
        id
        item {
          id
          externalId
        }
      }
    }
  }
`
